import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router';

import { PanelHeader, PanelBody } from '../react-common';
import LockboxAccessLogs from '../listing/appointments/LockboxAccessLogs';

const LockboxBrandMap = {
  masterlock: 'Master Lock',
  sentrilock: 'SentriLock',
} as const;

type LockboxAccessLogPageProps = {
  $routeParams: {
    deviceId: string;
    lockboxType: 'masterlock' | 'sentrilock';
  };
};

const LockboxAccessLogPage: React.FC<LockboxAccessLogPageProps> = ({
  $routeParams,
}) => {
  let { lockboxType, deviceId } =
    useParams<LockboxAccessLogPageProps['$routeParams']>();

  if ($routeParams) ({ lockboxType, deviceId } = $routeParams);

  return (
    <div className="bb--angular">
      <PanelHeader
        title={`Lock Box Access - ${LockboxBrandMap[lockboxType]} / ${deviceId}`}
        extra={[
          <span className="pull-right margin-right" key={0}>
            <a className="btn btn-primary" href="#/lockboxes">
              Back
            </a>
          </span>,
        ]}
      />
      <PanelBody>
        <LockboxAccessLogsContainer>
          <LockboxAccessLogs lockboxType={lockboxType} deviceId={deviceId} />
        </LockboxAccessLogsContainer>
      </PanelBody>
    </div>
  );
};

export default LockboxAccessLogPage;

const LockboxAccessLogsContainer = styled.div`
  width: 100%;
`;
